import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  removeBlankOut() {
    $('div#blank_out').remove();
  }
}
